import { PARTS, computeStats, defaultBey } from './PartData.js';
import { PreviewRenderer } from './PreviewRenderer.js';
import { BattleScene } from './BattleScene.js';
import * as Audio from './Audio.js';

// ── State ──
const beys = {
  1: defaultBey(1),
  2: defaultBey(2),
};
let currentPlayer = 1;
let selectedArena = 'classic';
let previewRenderer = null;
let battleScene = null;

// ── Unlock audio on first click ──
document.addEventListener('click', () => Audio.unlock(), { once: true });

// ── DOM refs ──
const mainMenu = document.getElementById('main-menu');
const customizeScreen = document.getElementById('customize-screen');
const arenaScreen = document.getElementById('arena-screen');
const battleHud = document.getElementById('battle-hud');

// ══════════════════════════════════════════════════
//  MAIN MENU
// ══════════════════════════════════════════════════
document.getElementById('btn-customize').addEventListener('click', () => {
  mainMenu.classList.add('hidden');
  customizeScreen.classList.remove('hidden');
  openCustomize();
});

document.getElementById('btn-battle').addEventListener('click', () => {
  mainMenu.classList.add('hidden');
  arenaScreen.classList.remove('hidden');
});

document.getElementById('btn-back-hub').addEventListener('click', () => {
  window.location.href = '/';
});

// ══════════════════════════════════════════════════
//  CUSTOMIZATION
// ══════════════════════════════════════════════════
function openCustomize() {
  currentPlayer = 1;
  if (!previewRenderer) {
    previewRenderer = new PreviewRenderer();
  }
  previewRenderer.start();
  refreshCustomizeUI();
  previewRenderer.updateBey(beys[currentPlayer]);
}

function refreshCustomizeUI() {
  const bey = beys[currentPlayer];

  // Highlight player tab
  document.querySelectorAll('.player-tab').forEach(tab => {
    tab.classList.toggle('active', parseInt(tab.dataset.player) === currentPlayer);
  });

  // Highlight selected parts
  document.querySelectorAll('.part-btn').forEach(btn => {
    const part = btn.dataset.part;
    const value = btn.dataset.value;
    if (part === 'layer') btn.classList.toggle('selected', value === bey.layer);
    if (part === 'core') btn.classList.toggle('selected', value === bey.core);
    if (part === 'tip') btn.classList.toggle('selected', value === bey.tip);
  });

  // Highlight selected color
  document.querySelectorAll('.color-btn').forEach(btn => {
    btn.classList.toggle('selected', btn.dataset.color === bey.color);
  });

  // Update stats display
  updateStatsDisplay();

  // Update part descriptions
  document.getElementById('layer-stats').textContent = PARTS.layers[bey.layer].description;
  document.getElementById('core-stats').textContent = PARTS.cores[bey.core].description;
  document.getElementById('tip-stats').textContent = PARTS.tips[bey.tip].description;
}

function updateStatsDisplay() {
  const bey = beys[currentPlayer];
  const stats = computeStats(bey.layer, bey.core, bey.tip);

  const setFill = (id, value) => {
    const el = document.getElementById(id);
    el.style.width = (value * 10) + '%';
    // Color based on value
    if (value >= 8) el.style.background = 'linear-gradient(90deg, #22c55e, #4ade80)';
    else if (value >= 5) el.style.background = 'linear-gradient(90deg, #a855f7, #6366f1)';
    else el.style.background = 'linear-gradient(90deg, #ef4444, #f59e0b)';
  };

  setFill('stat-attack', stats.attack);
  setFill('stat-defense', stats.defense);
  setFill('stat-stamina', stats.stamina);
  setFill('stat-speed', stats.speed);
  setFill('stat-weight', stats.weight);
}

// Player tab switching
document.querySelectorAll('.player-tab').forEach(tab => {
  tab.addEventListener('click', () => {
    currentPlayer = parseInt(tab.dataset.player);
    refreshCustomizeUI();
    previewRenderer.updateBey(beys[currentPlayer]);
  });
});

// Part selection
document.querySelectorAll('.part-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const part = btn.dataset.part;
    const value = btn.dataset.value;
    beys[currentPlayer][part] = value;
    refreshCustomizeUI();
    previewRenderer.updateBey(beys[currentPlayer]);
  });
});

// Color selection
document.querySelectorAll('.color-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    beys[currentPlayer].color = btn.dataset.color;
    refreshCustomizeUI();
    previewRenderer.updateBey(beys[currentPlayer]);
  });
});

// Done customizing
document.getElementById('btn-done-customize').addEventListener('click', () => {
  if (previewRenderer) previewRenderer.stop();
  customizeScreen.classList.add('hidden');
  mainMenu.classList.remove('hidden');
});

// ══════════════════════════════════════════════════
//  ARENA SELECT
// ══════════════════════════════════════════════════
document.querySelectorAll('.arena-card').forEach(card => {
  card.addEventListener('click', () => {
    document.querySelectorAll('.arena-card').forEach(c => c.classList.remove('selected'));
    card.classList.add('selected');
    selectedArena = card.dataset.arena;
  });
});

document.getElementById('btn-back-menu').addEventListener('click', () => {
  arenaScreen.classList.add('hidden');
  mainMenu.classList.remove('hidden');
});

document.getElementById('btn-start-battle').addEventListener('click', () => {
  arenaScreen.classList.add('hidden');
  startBattle();
});

// ══════════════════════════════════════════════════
//  BATTLE
// ══════════════════════════════════════════════════
function startBattle() {
  if (!battleScene) {
    battleScene = new BattleScene();
  }

  battleScene.initBattle(beys[1], beys[2], selectedArena);

  // Countdown then begin
  battleScene.startCountdown(() => {
    battleScene.beginBattle();
  });
}

// Rematch
document.getElementById('btn-rematch').addEventListener('click', () => {
  Audio.stopSpinSound();
  document.getElementById('battle-hud').classList.add('hidden');
  startBattle();
});

// Back to menu
document.getElementById('btn-to-menu').addEventListener('click', () => {
  Audio.stopSpinSound();
  document.getElementById('battle-hud').classList.add('hidden');
  mainMenu.classList.remove('hidden');
});
